// extracted by mini-css-extract-plugin
export default {"container":"OtpInput_container__Th9I2","content":"OtpInput_content__Tlvxa"};